'use strict';

var Sugar = require('sugar-core'),
    dateIsValid = require('./internal/dateIsValid');

Sugar.Date.defineInstance({

  'isValid': function(date) {
    return dateIsValid(date);
  }

});

module.exports = Sugar.Date.isValid;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isValid.js
// module id = 251
// module chunks = 1